import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, CardHeader } from "reactstrap";
import LeftSideFilter from "./LeftSideFilter";
import Filter from "./Filter";
import StudentList from "./StudentList";
import { useHistory } from "react-router";
import { filterFormModal } from "views/pages/manage/unAssigned/studentCharges/common";
import { searchInputFormModal } from "views/pages/manage/edpOps/constant/student-search";
import { useRegionAndBusinessArea } from "views/pages/manage/common/utils/customHooks";
import { dropdownMapping } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { loadDropdowns } from "redux/studentSearch/actions";
import { searchStudentClear } from "redux/studentCharges/actions";
import { searchStudentPaymentApplications } from "redux/studentCharges/actions";
import { isFilterApplied } from "views/pages/manage/edpOps/constant/batch-search";
import ALoader from "views/pages/manage/common/a-loader";
import { endpoint } from "views/pages/manage/common/constant";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";

export const emptySearchFields = {
  psid: "",
  applicationId: "",
  opportunityId: "",
  studentName: "",
};

const StudentSearchPage = ({
  setPopover,
  rows,
  setRows,
  globalFilter,
  studentSearch,
  setGlobalFilter,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchInputForm, setSearchInputForm] = useState(searchInputFormModal);
  const [regionAndBusiness, setRegionAndBusiness] = useRegionAndBusinessArea();
  const [currentPageNumber, setPageNumber] = useState(0);
  const [appliedFilterCount, setAppliedFilterCount] = useState(0);
  const [isLastPage, setIsLastPage] = useState(false);
  const [businessAreaMap, setBusinessAreaMap] = useState({
    region: studentSearch?.dropdowns?.region ?? [],
    businessArea: globalFilter?.businessArea
      ? globalFilter?.businessArea
      : studentSearch?.dropdowns?.businessArea ?? [],
  });
  const [courseIdDropdown, setCourseIdDropdown] = useState([]);

  const setFilterForm = (value) => {
    setGlobalFilter({ ...globalFilter, ...value });
  };

  const inputHandler = (value, inputName) => {
    let currentData = { ...globalFilter };
    if (inputName === "businessAreaClear") {
      currentData = { ...globalFilter, businessArea: [] };
      currentData["region"] = value;
      setFilterForm(currentData);
    } else {
      currentData[inputName] = value;
      setFilterForm(currentData);
    }
  };

  const getAllCourseIds = async () => {
    const res = await dropdownMapping(
      endpoint?.courseCatelogMapping?.getAllActiveCourseIds,
      "courseIds"
    );
    setCourseIdDropdown(res);
  };

  useEffect(() => {
    getAllCourseIds();
    setAppliedFilterCount(isFilterApplied(globalFilter));
    dispatch(
      loadDropdowns((data) => {
        setRegionAndBusiness({
          region: data?.regions ?? [],
          businessArea: globalFilter?.businessArea
            ? globalFilter?.businessArea
            : studentSearch?.dropdowns?.businessArea ?? [],
        });
        setBusinessAreaMap({
          region: data?.regions ?? [],
          businessArea: globalFilter?.businessArea
            ? globalFilter?.businessArea
            : data?.businessAreas ?? [],
        });
      })
    );
    return () => dispatch(searchStudentClear());
  }, []);

  const searchHandler = (f) => {
    setPageNumber(0);
    dispatch(searchStudentPaymentApplications({ ...f }));
  };

  const nextButtonHandler = (pageNumber) => {
    dispatch(
      searchStudentPaymentApplications(
        {
          ...globalFilter,
          courseId: globalFilter?.courseId?.map((i) => i.value) ?? [],
          term: globalFilter?.term?.map((i) => i.value) ?? [],
          chargesStatus: globalFilter?.chargesStatus?.map((i) => i.value) ?? [],
          paymentStatus: globalFilter?.paymentStatus?.map((i) => i.value) ?? [],
        },
        pageNumber,
        setPageNumber,
        setIsLastPage
      )
    );
  };

  const applyFilterHandler = () => {
    setPageNumber(0);
    dispatch(
      searchStudentPaymentApplications(
        { ...globalFilter, ...searchInputForm },
        0
      )
    );
    setAppliedFilterCount(isFilterApplied(globalFilter));
  };

  const removeFilterHandler = () => {
    setPageNumber(0);
    dispatch(
      searchStudentPaymentApplications(
        { ...filterFormModal, ...searchInputForm },
        0
      )
    );
    setAppliedFilterCount(0);
    setFilterForm(filterFormModal);
  };

  const crossInputHandler = () => {
    setPageNumber(0);
    setFilterForm({ ...globalFilter, ...emptySearchFields });
    dispatch(
      searchStudentPaymentApplications(
        { ...globalFilter, ...emptySearchFields },
        0
      )
    );
  };
  const searchInputValueHandler = (name) => {
    setPageNumber(0);
    dispatch(searchStudentPaymentApplications({ ...globalFilter }, 0));
  };

  return (
    <>
      <div
        className={`remove-container-top-space d-flex px-3 py-4 align-items-center`}
      >
        <BackIcon
          className="mr-2 large-text"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setPopover(false);
          }}
        />
        <div className="heading-4 color-black-60 large-text">Student List</div>
      </div>
      <div
        style={{
          position: "relative",
          display: "flex",
          flexFlow: "column",
          height: "calc(100vh - 120px)",
        }}
      >
        {studentSearch.loading && <ALoader />}
        <Card className="mx-3 mb-2" style={{ flexGrow: 1 }}>
          <CardBody style={{ display: "flex", flexFlow: "column" }}>
            <div className="search-match-container">
              <LeftSideFilter
                searchHandler={searchHandler}
                setFilterForm={setFilterForm}
                businessAreaMap={businessAreaMap}
                setBusinessAreaMap={setBusinessAreaMap}
              />
              <Filter
                filterForm={globalFilter}
                setNormalFilterForm={setFilterForm}
                inputHandler={inputHandler}
                applyFilterHandler={applyFilterHandler}
                setAppliedFilterCount={setAppliedFilterCount}
                appliedFilterCount={appliedFilterCount}
                removeFilterHandler={removeFilterHandler}
                crossInputHandler={crossInputHandler}
                courseIdDropdown={courseIdDropdown}
                setFilterForm={searchInputForm}
                setGlobalFilter={setGlobalFilter}
                searchInputValueHandler={searchInputValueHandler}
                setRows={setRows}
              />
            </div>
            <StudentList
              rowsData={studentSearch.studentList || []}
              rowCount={studentSearch.rowCount || 0}
              nextButtonHandler={nextButtonHandler}
              currentPage={currentPageNumber}
              businessAreaMap={businessAreaMap}
              isLastPage={isLastPage}
              setRows={setRows}
            />
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default StudentSearchPage;
